import colors from '@styles/colors.module.scss';

const { fgColors, bgColors } = colors;

// this exports all the foreground and background color defined in _colors file into js object using all cap'ed keys
// eg: ColorStyles.BGRED  | colorStyles.BLUE
// any shared comp can then utilize similar syntax from brButton.scss to auto map each colorstyles to respective styling
const ColorStyles: Record<string, string> = {};
`${fgColors}, ${bgColors}`.split(',').forEach((color) => {
  const trimmedColor = color.trim();
  ColorStyles[trimmedColor.toUpperCase()] = trimmedColor;
});
export default ColorStyles;
